<template>
  <v-container fluid style="overflow: hidden !important;" class="CSChatThai">
    <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12 v-if="progress">
        <v-layout row wrap justify-center align-center class="height-100vh">
          <v-progress-circular :size="100" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex sm12 md12 lg12 xl12 v-else>
        <v-content>
          <v-container fluid fill-height>
            <v-layout justify-center class="chatboxnonselect" column>
              <v-layout row wrap>
                <v-flex sm12 md12 lg12 xl12>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-0">
                <v-flex sm12 md12 xl12 lg12>
                <v-tabs left color="white" dark icons-and-text v-model="tabs" class="mt-2">
                  <v-tabs-slider color="#232b35"></v-tabs-slider>

                  <v-tab :key="1" href='#tab-1'>
                    <p style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.friend')}}</p>
                    <v-icon color="#232b35">fas fa-user</v-icon>
                  </v-tab>

                  <v-tab :key="2" href='#tab-2'>
                    <p style="color: #232b35; text-transform: none;">{{$t('LeftSide.friend.group')}}</p>
                    <v-icon color="#232b35">fas fa-users</v-icon>
                  </v-tab>
                  <v-tabs-items>
                    <v-tab-item id="tab-1">
                      <v-flex xs12 sm12 md12 xl12 lg12 v-if="listproject_user.length != 0">
                        <v-card class="card-tabs" color="primary">
                          <v-container grid-list-lg fluid style="min-height: 0; height: calc(100vh - 180px) !important;" class="scrolling-wrapper">
                            <v-layout row wrap class="mt-4 mr-5 ml-5">
                              <v-flex
                                v-for="(item, index) in FilterListProject"
                                :key="index"
                                xs6
                                class="mt-1 mb-2"
                              >
                                <v-card class="card-project" @click="topage_task(item._id, item.tokenroom)">
                                  <v-layout column>
                                    <v-flex xs12 md12 sm12 lg12 xl12 @click="topage_task(item._id, item.tokenroom)">
                                      <v-layout row wrap>
                                        <div class="font-size-20 font-weight-bold text-overflow-project ml-4 mt-2">{{item.project_name}}</div>
                                        <v-spacer></v-spacer>
                                        <div class="color-grey mr-4 mt-3" style="font-size: 12px;">
                                          {{datetime(item.timestamp)}}
                                        </div>
                                      </v-layout>
                                      <!-- <v-card-title primary-title>
                                        <v-layout row wrap>
                                          <div class="font-size-20 font-weight-bold text-overflow-project">{{item.project_name}}</div>
                                          <v-spacer></v-spacer>
                                          <div class="color-grey" style="font-size: 12px;">
                                            {{datetime(item.timestamp)}}
                                          </div>
                                        </v-layout>
                                      </v-card-title> -->
                                      <!-- <v-layout column class="ml-2" v-if="item.detail !== ''">
                                        <div class="text-overflow-detail" style="font-size: 14px;">
                                          {{item.detail}}
                                        </div>
                                      </v-layout> -->
                                      <v-card-actions>
                                        <v-layout column justify-end class="ml-2 mt-0">
                                          <div class="text-overflow-detail" style="font-size: 13px;">
                                            {{item.detail}}
                                          </div>
                                        </v-layout>
                                        <!-- <v-chip text-color="primary" outline label>
                                          {{$t('Task.allTask.numTask',{count: item.count_task})}}
                                        </v-chip> -->
                                        <template v-for="i in item.state">
                                          <v-chip small label class="chipColorTodo" v-if="i.name.includes('Todo') || i.name.includes('todo')">
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                          <v-chip small label class="chipColorDoing" v-else-if="i.name.includes('Doing') || i.name.includes('doing')">
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                          <v-chip small label class="chipColorDone" v-else-if="i.name.includes('Done') ||i.name.includes('done')">
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                          <v-chip small label class="chipColorEtc" v-else>
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                        </template>
                                        <!-- <v-chip  v-for="i in item.state" label  class="chipColor">
                                          {{i.name}} {{i.count_member}}
                                        </v-chip> -->
                                        <!-- <v-avatar size="40px">
                                          <img :src="item.path_pic" v-if="item.path_pic" class="object-fit-img">
                                          <img src="/static/img/default_profile/man-white.png" alt="" v-else class="border-img object-fit-img">
                                        </v-avatar> -->
                                        <!-- <v-spacer></v-spacer> -->
                                        <!-- <v-avatar size="40px">
                                          <img :src="item.path_pic" alt="alt" class="" v-if="item.path_pic" class="object-fit-img">
                                          <img src="/static/img/default_profile/man-white.png" alt="" v-else class="border-img object-fit-img">
                                        </v-avatar> -->
                                          <!-- <span class="pl-3 pr-3 detailProject" style="margin-top: 23px;">
                                            {{$t('Task.allTask.moreDetail')}}
                                          </span>
                                          <v-icon class="iconDetail" style="margin-top: 23px;">fas fa-angle-right</v-icon> -->
                                      </v-card-actions>
                                      <!-- <v-divider light class="mt-2 divider"></v-divider> -->
                                      <v-layout row wrap class="ml-3 mb-2">
                                        <v-avatar size="35px">
                                          <img :src="item.path_pic" v-if="item.path_pic" class="object-fit-img">
                                          <img src="/static/img/default_profile/man-white.png" alt="" v-else class="border-img object-fit-img">
                                        </v-avatar>
                                        <div class="text-overflow-project mt-2 ml-2" style="font-size: 14px;">{{item.room_name}}</div>
                                        <!-- <span class="pl-3 pr-3 detailProject">
                                          รายละเอียดเพิ่มเติม
                                        </span>
                                        <v-spacer></v-spacer>
                                        <v-icon class="iconDetail">fas fa-angle-right</v-icon> -->
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm12 md12 xl12 lg12 v-else class="flex-center cal-height-100vh">
                        <v-layout column wrap justify-center align-center>
                          <v-icon style="font-size: 60px !important;">fas fa-tasks</v-icon>
                          <h4 class="mt-3">{{$t('Task.allTask.noProjectList')}}</h4>
                        </v-layout>
                      </v-flex>
                    </v-tab-item>

                    <v-tab-item id="tab-2">
                      <v-flex xs12 sm12 md12 xl12 lg12 v-if="listproject_group.length != 0">
                        <v-card class="card-tabs">
                          <v-container grid-list-lg fluid style="min-height: 0; height: calc(100vh - 180px) !important;" class="scrolling-wrapper">
                            <v-layout row wrap class="mt-4 mr-5 ml-5">
                              <v-flex
                                v-for="(item, index) in FilterListProjectGroup"
                                :key="index"
                                xs6
                                class="mt-1 mb-2"
                              >
                                <v-card class="card-project" @click="topage_task(item._id, item.tokenroom)">
                                  <v-layout column>
                                    <v-flex xs12 md12 sm12 lg12 xl12 @click="topage_task(item._id, item.tokenroom)">
                                      <v-layout row wrap>
                                        <div class="font-size-20 font-weight-bold text-overflow-project ml-4 mt-2">{{item.project_name}}</div>
                                        <v-spacer></v-spacer>
                                        <div class="color-grey mr-4 mt-3" style="font-size: 12px;">
                                          {{datetime(item.timestamp)}}
                                        </div>
                                      </v-layout>
                                      <!-- <v-card-title primary-title>
                                        <v-layout row>
                                          <div class="font-size-20 font-weight-bold text-overflow-project">{{item.project_name}}</div>
                                          <v-spacer></v-spacer>
                                          <div class="color-grey" style="font-size: 12px; margin-top: 9px;">
                                            {{$t('Task.allTask.createDate',{date: datetime(item.timestamp)})}}
                                          </div>
                                        </v-layout>
                                      </v-card-title> -->
                                      <v-card-actions>
                                         <v-layout column justify-end class="ml-2 mt-0">
                                          <div class="text-overflow-detail" style="font-size: 13px;">
                                            {{item.detail}}
                                          </div>
                                        </v-layout>
                                        <template v-for="i in item.state">
                                          <v-chip small label class="chipColorTodo" v-if="i.name.includes('Todo') || i.name.includes('todo')">
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                          <v-chip small label class="chipColorDoing" v-else-if="i.name.includes('Doing') || i.name.includes('doing')">
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                          <v-chip small label class="chipColorDone" v-else-if="i.name.includes('Done') ||i.name.includes('done')">
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                          <v-chip small label class="chipColorEtc" v-else>
                                            {{i.name}} {{i.count_member}}
                                          </v-chip>
                                        </template>
                                        <!-- <v-chip text-color="primary" outline label>
                                          {{$t('Task.allTask.numTask',{count: item.count_task})}}
                                        </v-chip> -->
                                        <!-- <v-chip v-for="i in item.state" label  class="chipColor">
                                          {{i.name}} {{i.count_member}}
                                        </v-chip> -->
                                        <!-- <v-avatar size="40px">
                                          <img :src="item.path_pic" alt="alt" v-if="item.path_pic" class="object-fit-img">
                                          <img src="/static/img/default_profile/group-white.png" alt="" v-else class="border-img object-fit-img">
                                        </v-avatar>
                                        <v-spacer></v-spacer>
                                        <span class="pl-3 pr-3 detailProject" style="margin-top: 23px;">
                                            {{$t('Task.allTask.moreDetail')}}
                                        </span>
                                        <v-icon class="iconDetail" style="margin-top: 23px;">fas fa-angle-right</v-icon> -->
                                      </v-card-actions>
                                      <!-- <v-divider light class="mt-2  divider"></v-divider> -->
                                      <v-layout row wrap class="ml-3 mb-2">
                                        <v-avatar size="35px">
                                          <img :src="item.path_pic" v-if="item.path_pic" class="object-fit-img">
                                          <img src="/static/img/default_profile/man-white.png" alt="" v-else class="border-img object-fit-img">
                                        </v-avatar>
                                        <div class="text-overflow-project mt-2 ml-2" style="font-size: 14px;">{{item.room_name}}</div>
                                        <!-- <span class="pl-3 pr-3 detailProject">
                                          รายละเอียดเพิ่มเติม
                                        </span>
                                        <v-spacer></v-spacer>
                                        <v-icon class="iconDetail">fas fa-angle-right</v-icon> -->
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm12 md12 xl12 lg12 v-else class="flex-center cal-height-100vh">
                        <v-layout column wrap justify-center align-center>
                          <v-icon style="font-size: 60px !important;">fas fa-tasks</v-icon>
                          <h4 class="mt-3">{{$t('Task.allTask.noProjectList')}}</h4>
                        </v-layout>
                      </v-flex>
                    </v-tab-item>
                  </v-tabs-items>
                  <v-layout row wrap align-center justify-end class="ml-3 mr-4 bg-white" v-if="tabs == 'tab-1'">
                    <v-flex sm6 md6 lg6 xl6 class="ml-3 mt-3" v-if="listproject_user.length != 0">
                      <v-text-field
                        v-model="search"
                        solo
                        :label="$t('Task.allTask.placeholderSearchProject')"
                        clearable
                        append-icon="search"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap align-center justify-end class="ml-3 mr-4 bg-white" v-else>
                    <v-flex sm6 md6 lg6 xl6 class="ml-3 mt-3" v-if="listproject_group.length != 0">
                      <v-text-field
                        v-model="search_group"
                        solo
                        :label="$t('Task.allTask.placeholderSearchProject')"
                        clearable
                        append-icon="search"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-tabs>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-content>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode, Momenttime } from '@/services'
var _ = require('lodash')
export default {
  // props: {
  //   source: String
  // },
  components: {
  },
  data () {
    return {
      tabs: '',
      listproject: [],
      status_login: '',
      windowWidth: '',
      token: '',
      progress: false,
      search: '',
      search_group: '',
      listproject_user: [],
      listproject_group: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.status_login = decoded['status_login']
    this.get_project_room()
  },
  computed: {
    ...sync('*'),
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    FilterListProject () {
      if (this.search !== '' && this.search !== null) {
        return this.listproject_user.filter(post => {
          return post.project_name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listproject_user
      }
    },
    FilterListProjectGroup () {
      if (this.search_group !== '' && this.search_group !== null) {
        return this.listproject_group.filter(post => {
          return post.project_name.toLowerCase().includes(this.search_group.toLowerCase())
        })
      } else {
        return this.listproject_group
      }
    }
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage')
      }
    }
  },
  methods: {
    topage_task (projectid, tokenroom) {
      // console.log(projectid)
      this.$router.push('/chat/task/' + projectid + '/' + tokenroom)
    },
    momentday (timestamp) {
      return Momenttime.momentdatethai(timestamp)
    },
    datetime (timestamp) {
      return (this.$i18n.locale == 'th')? Momenttime.momentdatethai(timestamp): Momenttime.momentdateen(timestamp)
    },
    toChatroom () {
      // this.$router.push('/chat/room/' + this.$route.params.roomid)
      this.$router.go(-1)
    },
    get_project_room () {
      this.progress = true
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_tokenuser', {
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.listproject = response.data.data
          this.listproject = _.reverse(_.sortBy(this.listproject, function (dateObj) {
            return new Date(dateObj.timestamp)
          }))
          // console.log(this.listproject)
          this.listproject_group = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('G') })
          this.listproject_user = _.filter(this.listproject, function(o) { return o.tokenroom.startsWith('R') })
        }
      }).catch(error => {
        console.log(error.message)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
/* >>>.v-window {
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
} */
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.cal-height-100vh {
  height: calc(100vh - 128px) !important;
}
>>>.v-chip .v-chip__content {
  cursor: default !important;
  justify-content: space-between !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  white-space: nowrap !important;
  z-index: 1 !important;
  height: 17px !important;
}
.flex-center {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.color-grey {
  color: #616161 !important;
}
.font-size-20 {
  font-size: 20px !important;
}
.bg-white {
  background-color: white !important;
}
.card-tabs {
  background-image: linear-gradient(to right, rgba(192, 203, 250, 0.808),rgb(178, 208, 216)) !important;
  border-radius: 10px !important;
  margin-left: 80px !important;
  margin-right: 80px !important;
  border-style: solid !important;
  border-color: #f1f1f2 !important;
  border-width: thin !important;
  margin-top: 30px !important;
}
.text-overflow-project {
  width: 45%;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.text-overflow-detail {
  height: 3em;
  text-indent: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 90%;
}
.span-detail-project {
  color: #8e8e92 !important;
  margin-left: 20px !important;
}
.card-project {
  border-radius: 10px !important;
  background-color: white !important;
  height: auto !important;
  /* width: 380px; */
  cursor: pointer !important;
}
.iconDetail{
  margin-right: 15px;
}
.card-project:hover {
  border-radius: 10px !important;
  /* background-color: #1d5eafeb !important; */
  background-image: linear-gradient(to bottom, rgb(255, 255, 255), rgba(254, 254, 254, 0.808)) !important;
  /* background-image: linear-gradient(to bottom, rgb(253, 248, 223), rgba(255, 255, 255, 0.808)) !important; */
  color: white;
  height: auto !important;
  cursor: pointer !important;
  box-shadow: 0 7px 7px rgba(0,0,0,0.25), 0 1px 4px rgba(0,0,0,0.22);
  -webkit-box-shadow: 0 7px 7px rgba(0,0,0,0.25), 0 1px 4px rgba(0,0,0,0.22);
}
.card-project:hover .text-overflow-project
 {
  color: #2562af !important;
}
.detailProject{
  color: #616161
}
.card-project:hover .detailProject
 {
  color: #103567c7 !important;
}
.card-project:hover .iconDetail
 {
  color: #103567c7 !important;
}
/* .card-project:hover .color-grey
 {
  color: #2562af !important;
} */
.card-project:hover .color-grey[data-v-1e5e01de] {
    color: #103567c7 !important;
}
.chipColor{
  color: #2562af;
  background-color: transparent;
  border: 1px #2562af solid;
}
.chipColorTodo {
  color: #667684;
  background-color: transparent;
  border: 1px #667684 solid;
}
.chipColorDoing {
  color: #33bcd4;
  background-color: transparent;
  border: 1px #33bcd4 solid;
}
.chipColorDone {
  color: #6bc94f;
  background-color: transparent;
  border: 1px #6bc94f solid;
}
.chipColorEtc {
  color: #bcc0c7;
  background-color: transparent;
  border: 1px #bcc0c7 solid;
}
.card-project:hover .chipColor{
  color: white !important;
  background-color: #6089ba !important;
}
.span-timestamp {
  font-size: 14px !important;
  color: grey !important;
}
>>>.v-list {
    /* min-width: 210px !important; */
    max-width: 100% !important;
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.text-transform {
  /* text-transform: uppercase; */
  text-transform: capitalize !important;
}
.btn-plus-user {
  background-color: #efefef !important;
  color: #1d1d1d !important;
  box-shadow: none !important;
}
.font-size18 {
  font-size: 18px !important;
}
.font-title-task {
  font-size: 19px !important;
  font-weight: 500 !important;
}
/* >>>.v-list__tile .theme--light {
  height: 200px !important;
} */
/* >>>.v-navigation-drawer .v-list .v-list__tile {
  height: 200px !important;
  transition: none !important;
  font-weight: 500 !important;
} */
.card-task-pri1 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #b3493d !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.card-task-pri2 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #fcbe55 !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.card-task-pri3 {
  background-color: white !important;
  color: black !important;
  border-style: solid !important;
  border-radius: 10px !important;
  border-width: thin !important;
  /* margin-bottom: 15px; */
  /* border-color: #1b232d; */
  margin-top: 10px !important;
  margin-left: 5px !important;
  margin-right: 5px !important;
  border-left-color: #a0a1a3 !important;
  border-left-width: 12px !important;
  /* border-left-style: solid; */
  height: 100px !important;
  cursor: pointer !important;
}
.overflow-scroll {
  overflow-y: scroll !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
.border-img {
  border-color: #80808052 !important;
  border-style: solid !important;
  border-width: thin !important;
}
.margin-top-120px {
  margin-top: 120px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
  text-align: center !important;
}
.text-overflow-groupname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 180px !important;
  /* text-align: center !important; */
}
.text-overflow-list {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 190px !important;
}
.color-white {
  color: white !important;
}
/* >>>.v-list__tile__content {
  height: 70vh;
  margin-top: 50px;
} */
.height-100vh {
  height: 100vh !important;
}
.height-200px {
  height: 200px !important;
}
.height-300px {
  height: 300px !important;
}
.width-100 {
  width: 100% !important;
}
.color-card-task {
  overflow: scroll !important;
  height: 60vh !important;
  margin-top: 20px !important;
  border-radius: 6px !important;
  background-color: #f1f1f1 !important;
}
.system-bar {
  height: 4px !important;
  background-color: #e0e0e0 !important;
  border-radius: 10px !important;
  /* margin-left: 18px !important; */
}
.font-size-16 {
  font-size: 16px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.span-clear-filter {
   color: #949494 !important;
   font-size: 16px !important;
}
>>>.v-input__slot {
  border-radius: 13px !important;
  box-shadow: none !important;
  background-color: rgba(142, 142, 147, 0.12156862745098039) !important;
}
>>>.v-text-field.v-text-field--solo .v-label {
  font-size: 14px;
}
>>>.theme--dark.v-label {
    color: rgba(0,0,0,.54) !important;
}
>>>.theme--dark.v-icon {
    color: rgb(35, 43, 53) !important;
}
>>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: rgba(0,0,0,.54) !important;
}
.btn-filter-task {
  border-radius: 6px !important;
  border: solid 1px #2562af !important;
  color: #2562af !important;
  background-color: white !important;
  box-shadow: none !important;
}
.icon-filter-task {
  color: #2562af !important;
  font-size: 16px !important;
}
.icon-create-task{
  color: white !important;
  font-size: 16px !important;
}
.btn-create-task {
  background-color: #2561b0 !important;
  /* border-color: #2561b0 !important; */
  border-style: solid !important;
  border-radius: 6px !important;
  color: white !important;
  box-shadow: none !important;
}
.btn-nav {
  background-color: #d8d8d8 !important;
}
>>>.v-list .v-list--dense .theme--light {
  margin-top: 70px !important;
}
.bg-flex-1 {
  background-color: #1b232d;
}
.container{
  padding: 0px !important;
}
.fixed-content {
  min-height:100%;
  /*position:fixed;*/
  overflow-y:scroll;
  overflow-x:hidden;
}
.content {
  padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect {
  width: 100%;
  min-width: 10vw;
  height: calc(100vh - 64px);
  background-color:white;
  overflow-y: hidden;
}
.btn-color {
  background-color: white !important;
  border-color: #2561b0 !important;
  border-style: solid !important;
  border-radius: 6px !important;
  color: #2561b0 !important;
  box-shadow: none !important;
}
.icon-color {
  color: #2561b0 !important;
}
>>> .theme--light.v-card {
    background-color: #fff;
    border-color: none !important;
    color: rgba(0,0,0,.87);
}
>>>.v-timeline-item--left, .v-timeline-item:nth-child(odd):not(.v-timeline-item--right) {
    flex-direction: row;
    margin-right: 490px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/manage_task/homepage_all_project.vue